import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { useGetFiles } from 'shared/widgets/TableFileViewer/hooks/useGetFiles';
import { TableFileViewer } from 'shared/widgets/TableFileViewer/TableFileViewer';
import { Commission } from 'types/embedded/commission';

import { useCommissionsEditable } from './hooks/useCommissionsEditable';
import { useCommissionsShow } from './hooks/useCommissionsShow';

export const CommissionsTabsFiles: React.FC = () => {
  const translate = useTypedTranslate();
  const record = useRecordContext<Commission>();
  const { checkCommissionsEditable } = useCommissionsEditable();
  const { isCommissionsShow } = useCommissionsShow();

  const { data: files } = useGetFiles(Resources.Commissions, record?.originId);

  return record && (checkCommissionsEditable(record) || (files && files?.length > 0)) ? (
    <TableFileViewer
      allowShow={isCommissionsShow}
      allowUpdate={checkCommissionsEditable(record)}
      entityId={record?.originId}
      entityName="commission"
    />
  ) : (
    <Alert severity="info">{translate('app.commissions.noFiles')}</Alert>
  );
};
